import script from "./AddUpdateRole.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUpdateRole.vue?vue&type=script&setup=true&lang=js"

export default script